import dynamic from 'next/dynamic';
import React from 'react';
import { PageType } from '@hotelplan/graphql.types';
import { useFeatureToggle } from '@hotelplan/libs.feature-toggle';
import MyAccountLayout from 'components/domain/my-account/MyAccountLayout';
import { useMyAccountTabs } from 'components/domain/my-account/useMyAccountTabs';
import { MyAccountWishlistOverviewContainer } from 'components/domain/my-account/wishlist';
import { WishlistContainer } from 'components/domain/wishlist';
import { useWishlistTabs } from 'components/domain/wishlist/hooks';
import { WishlistTabs } from 'components/domain/wishlist/utils';
import { createPageServerFn } from 'config';
import { FeatureList } from 'config/pageConfig.constants';
import { wishlistPageUnit } from 'config/wishlist/wishlistPageUnit';
import { useGetWishlistLinksQuery } from 'graphql/wishlist/queries/GetWishlistLinks.generated';

const WishlistPageLayout = dynamic(
  () =>
    import('components/domain/wishlist').then(mod => mod.WishlistPageLayout),
  { ssr: false }
);

const WishlistListContent = dynamic(
  () =>
    import('components/domain/wishlist').then(mod => mod.WishlistListContent),
  { ssr: false }
);

export default function WishlistList(): React.ReactElement {
  const { isEnabled } = useFeatureToggle();
  const isMeinKontoEnabled = isEnabled(FeatureList.MEIN_KONTO);

  return isMeinKontoEnabled ? (
    <MyAccountWishlistList />
  ) : (
    <LegacyWishlistList />
  );
}

// TODO: Remove this component after mein-konto release
function LegacyWishlistList(): React.ReactElement {
  const { data: linkData } = useGetWishlistLinksQuery({ ssr: false });
  const tabItems = useWishlistTabs(linkData?.wishlist);

  return (
    <WishlistPageLayout tabKey={WishlistTabs.List} tabItems={tabItems}>
      <WishlistListContent />
    </WishlistPageLayout>
  );
}

function MyAccountWishlistList(): React.ReactElement {
  const { tabItems } = useMyAccountTabs();

  return (
    <MyAccountLayout tabItems={tabItems} tabKey={PageType.Wishlist}>
      <WishlistContainer className="wishlist-container">
        <MyAccountWishlistOverviewContainer>
          <WishlistListContent />
        </MyAccountWishlistOverviewContainer>
      </WishlistContainer>
    </MyAccountLayout>
  );
}

export const getServerSideProps = createPageServerFn(
  {
    pageType: PageType.WishlistList,
    pageEventType: 'wishlist',
    namespaceRequired: ['myaccount'],
  },
  [wishlistPageUnit]
);
